





















































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IItemForSelection } from '@/api/types/response.types'

/* API */
import DashboardAPI from '@/api/modules/dashboard.api'
import InternalProjectsAPI from '@/api/modules/internal-projects.api'
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default Vue.extend({
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: true,
      currentlyRestoringID: 0,
      archivedProjects: [] as IItemForSelection[],
      archivedMailboxes: [] as IItemForSelection[],
    }
  },

  computed: {
    internalShowModal: {
      get(): boolean {
        return this.showModal
      },
      set(newValue: boolean) {
        this.$emit('update:showModal', newValue)
      },
    },
    hasNoArchive(): boolean {
      return this.hasNoArchivedMailboxes && this.hasNoArchivedProjects
    },
    hasNoArchivedProjects(): boolean {
      return this.archivedProjects.length === 0
    },
    hasNoArchivedMailboxes(): boolean {
      return this.archivedMailboxes.length === 0
    },
    showFooter(): boolean {
      return !this.isLoading && !this.hasNoArchive
    },
  },

  watch: {
    internalShowModal: {
      async handler(value) {
        if (value) {
          this.isLoading = true
          await this.fetchArchived()
          this.isLoading = false
        }
      },
    },
  },

  methods: {
    async fetchArchived() {
      const response = await DashboardAPI.get_Archived()
      this.archivedProjects = response.listInternalProjects
      this.archivedMailboxes = response.listMailboxes
    },
    async restoreProject(id: number) {
      try {
        this.currentlyRestoringID = id
        const response = await InternalProjectsAPI.post_Restore(id)
        this.archivedProjects = this.archivedProjects.filter(p => p.id !== id)
        this.$messaging.showSuccess(response.message)
        this.$emit('project-restored')
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        this.currentlyRestoringID = 0
      }
    },
    async restoreMailbox(id: number) {
      try {
        this.currentlyRestoringID = id
        const response = await MailboxesAPI.post_Restore(id)
        this.archivedMailboxes = this.archivedMailboxes.filter(m => m.id !== id)
        this.$messaging.showSuccess(response.message)
        this.$emit('mailbox-restored')
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        this.currentlyRestoringID = 0
      }
    },
  },
})
